/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[wfmXssValidation]'
})
export class XssValidationDirective implements OnInit, OnDestroy {
  private keyupEvent;
  private pasteEvent;
  private pattern = /(<|%3c|&lt)script|(^')|('$)|(--)|(';)/gi;

  @Output() xssValidation = new EventEmitter<boolean>();

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.keyupEvent = this.renderer.listen(this.elementRef.nativeElement, 'keyup', this.textChange);
    this.pasteEvent = this.renderer.listen(this.elementRef.nativeElement, 'paste', this.textChange);
  }
  private textChange = e => {
    let input;
    if (e instanceof ClipboardEvent) {
      input = e.clipboardData.getData('Text');
    } else {
      input = this.elementRef.nativeElement.value;
    }
    const value = !!input && input.match(this.pattern);
    this.xssValidation.emit(input !== '' && value !== null);
  };

  ngOnDestroy(): void {
    this.keyupEvent();
    this.pasteEvent();
    this.xssValidation.complete();
  }
}
